export default "__VITE_ASSET__Jv0v_YT1__"